function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};

// react-import.js
import React from "react";

// src/index.tsx
import { EditorState, StateEffect } from "@codemirror/state";
import { EditorView } from "@codemirror/view";
import { forwardRef, useEffect as useEffect2, useMemo, useRef as useRef2, useState } from "react";

// src/merge-refs.ts
import React2 from "react";
function setRefs(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ;
    ref.current = value;
  }
}
function useMergeRefs(forwardedRef, localRef) {
  return React2.useCallback(function (value) {
    setRefs(forwardedRef, value);
    setRefs(localRef, value);
  }, [forwardedRef, localRef]);
}

// src/use-first-render.ts
import { useEffect, useRef } from "react";
var useFirstRender = function useFirstRender() {
  var firstRender = useRef(true);
  useEffect(function () {
    firstRender.current = false;
  }, []);
  return firstRender.current;
};

// src/index.tsx
var CodeMirror = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
    selection = _ref.selection,
    onEditorViewChange = _ref.onEditorViewChange,
    onEditorStateChange = _ref.onEditorStateChange,
    onUpdate = _ref.onUpdate,
    _ref$extensions = _ref.extensions,
    passedExtensions = _ref$extensions === void 0 ? [] : _ref$extensions,
    elementProps = _ref.elementProps;
  var innerRef = useRef2(null);
  var mergedRef = useMergeRefs(ref, innerRef);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    editorView = _useState2[0],
    setEditorView = _useState2[1];
  var updateExtension = useMemo(function () {
    return onUpdate ? EditorView.updateListener.of(onUpdate) : void 0;
  }, []);
  var extensions = useMemo(function () {
    return updateExtension ? [updateExtension].concat(_toConsumableArray(passedExtensions)) : passedExtensions;
  }, [updateExtension, passedExtensions]);
  var isFirstRender = useFirstRender();
  useEffect2(function () {
    var state = EditorState.create({
      doc: value,
      selection: selection,
      extensions: extensions
    });
    if (onEditorStateChange) onEditorStateChange(state);
    var view = new EditorView({
      parent: innerRef.current,
      state: state
    });
    setEditorView(view);
    if (onEditorViewChange) onEditorViewChange(view);
    return function () {
      return view.destroy();
    };
  }, [innerRef]);
  useEffect2(function () {
    if (isFirstRender || !editorView) return;
    editorView.dispatch({
      effects: StateEffect.reconfigure.of(extensions)
    });
  }, [passedExtensions]);
  useEffect2(function () {
    if (isFirstRender || !editorView) return;
    var transaction = editorView.state.update({
      selection: selection
    });
    editorView.dispatch(transaction);
  }, [selection, editorView]);
  useEffect2(function () {
    if (isFirstRender || !editorView) return;
    var transaction = editorView.state.update({
      changes: {
        from: 0,
        to: editorView.state.doc.length,
        insert: value
      },
      selection: editorView.state.selection
    });
    editorView.dispatch(transaction);
  }, [value, editorView]);
  return /* @__PURE__ */React.createElement("div", __spreadValues({
    ref: mergedRef
  }, elementProps));
});
CodeMirror.displayName = "CodeMirror";
var src_default = CodeMirror;
export { src_default as default };